export const AllowModeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25.0002 37.8652"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.0001 12.1155C6.70832 14.7207 7.47407 13.7582 7.47407 13.7582L12.5172 13.7582L17.5086 13.7582M7.83291 6.11548C8.54658 4.38359 9.93367 3.04395 12.5174 3.04395C19.8243 3.04395 17.5086 13.7582 17.5086 13.7582H7.47407"
      stroke="#24C35A"
      strokeWidth={2.90698}
      strokeLinecap="round"
    />
    <path
      d="M18.75 10.1865C22.2018 10.1865 25 12.9847 25 16.4365V31.6152C24.9999 35.067 22.2017 37.8652 18.75 37.8652H6.25C2.79827 37.8652 7.51824e-05 35.067 0 31.6152V16.4365C0 12.9847 2.79822 10.1865 6.25 10.1865H18.75Z"
      fill="#24C35A"
    />
    <path
      d="M4.97477 24.0063L10.2479 28.8973L19.0365 19.1152"
      stroke="white"
      strokeWidth={2.81235}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
